export default {
  text: {
    en: 'Discover our catalog of designer and niche scents from luxury labels, hand-selected by our team of fragrance experts.',
  },
  subtitle: {
    en: 'Over 700 fragrances are waiting',
  },
}
